module.exports = __webpack_public_path__ + "img/error.460787e9.svg";